import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { Tabs, Nav, NavItem } from 'elements/Tabs/Tabs';

class TabsBar extends Component {
  static propTypes = {
    tabs: PropTypes.array,
    history: PropTypes.object,
  }

  static defaultProps = {
    tabs: [],
  };

  handleNavItemClick = path => this.props.history.push(path);

  selectedTab = () => {
    const { history } = this.props;
    const splitedPaths = history.location.pathname.split('/');

    return splitedPaths[splitedPaths.length-1];
  }

  render () {
    const { tabs } = this.props;

    if (!tabs.length) { return null; }

    return (
      <Tabs id="tabsContainer" defaultActiveKey={0}>
        <Nav bsStyle='tabs' left>
          {tabs.map(tab =>
            <NavItem
              key={tab.path}
              onClick={this.handleNavItemClick.bind(this, tab.path)}
              active={tab.path === this.selectedTab()}
            >
              <label>{tab.label}</label>
            </NavItem>
          )}
        </Nav>
      </Tabs>
    );
  }
}

export default withRouter(TabsBar);



// WEBPACK FOOTER //
// ./src/components/TabsBar.js